import axios from 'axios';
import { getApiHeaders } from '../../utils/apiHelpers';

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api/gestione/haccp/lotti-produzione-avanzati`;

// Solo il responsabile modifica un'etichetta già creata
export const caricaPermessoModifica = async () => {
  try {
    const res = await axios.get(`${BASE}/permessi`, { headers: getApiHeaders() });
    return !!res.data.puo_modificare;
  } catch (e) {
    return false;
  }
};

// Salva e restituisce l'etichetta aggiornata; se gli allergeni erano corretti a mano chiede prima di sostituirli
export const salvaModificaEtichetta = async (lottoId, payload) => {
  let res = await axios.put(`${BASE}/${lottoId}`, payload, { headers: getApiHeaders() });
  const proposti = res.data.allergeni_proposti;
  if (proposti && window.confirm(
    `Gli allergeni di questa etichetta erano stati corretti a mano.\n`
    + `Con gli ingredienti attuali risultano: ${proposti.join(', ') || 'nessuno'}.\n\nVuoi sostituirli?`
  )) {
    res = await axios.put(`${BASE}/${lottoId}`, { sostituisci_allergeni: true }, { headers: getApiHeaders() });
  }
  return res.data.lotto;
};
